import React, { useEffect, useRef, useState } from 'react';

// Fades/slides its children in the first time they scroll into view.
// Animation styles live in src/animations.css (.rv / .rv-in); users with
// prefers-reduced-motion get the content immediately with no movement.
//   <Reveal>…</Reveal>                       slide up
//   <Reveal variant="left" delay={120}>…     slide in from the left, 120ms late
//   variants: up | left | right | scale | fade
export default function Reveal({ as: Tag = 'div', variant = 'up', delay = 0, className = '', style, children, ...rest }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === 'undefined') { setShown(true); return; }
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setShown(true); obs.disconnect(); }
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`rv rv-${variant}${shown ? ' rv-in' : ''}${className ? ' ' + className : ''}`}
      style={delay ? { ...style, transitionDelay: `${delay}ms` } : style}
      {...rest}
    >
      {children}
    </Tag>
  );
}
